import { useRef, StatelessComponent } from 'react'
import { getMonthsCount } from 'helpers/dateTimeHelpers'
import NetworthChangeModuleContainer from 'components/features/pfm/VerticalBarChart/NetworthChangeModuleContainer'
import NetworthMonthlyChangeModuleContainer from 'components/features/pfm/MonthlyBarChart/NetworthMonthlyChangeModuleContainer'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import ModuleWrapper from 'components/features/pfm/ModuleWrapper/ModuleWrapper'
import { InternalPageProps } from 'interfaces/pages'
import Anchor from 'components/atoms/navigation/Anchor'
import PageFooterButton from 'components/atoms/buttons/PageFooterButton'
import TrendRankContainer from 'components/features/pfm/TrendRank/TrendRankContainer'
import { NETWORTH_CHANGE_HINT } from 'constants/hints'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { PageParamsStickyHeader } from 'components/features/pfm/PageParamsHeader/PageParamsStickyHeader'
import { DesktopInternalStickyHeader } from 'components/features/pfm/DesktopInternalStickyHeader/DesktopInternalStickyHeader'
import { PageParamsHeader } from 'components/features/pfm/PageParamsHeader/PageParamsHeader'
import { useShouldShowPageParamsStickyHeader } from 'helpers/pageHelpers'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'

const NetworthPage: StatelessComponent<InternalPageProps> = ({ timeframe }) => {
  const isSingleMonth = getMonthsCount(timeframe) === 1

  /*const totalInflowsModule = (
    <ModuleWrapper title='Total Inflows' anchor='networth_inflows' hint={ NETWORTH_INFLOWS_HINT }>
      <MoneyflowSummaryModuleContainer type='income' timeframe={ timeframe } />
    </ModuleWrapper>
  )

  const totalOutflowsModule = (
    <ModuleWrapper title='Total Outflows' anchor='networth_outflows' hint={ NETWORTH_OUTFLOWS_HINT }>
      <MoneyflowSummaryModuleContainer type='spending' timeframe={ timeframe } />
    </ModuleWrapper>
  )*/

  const pageBody = (
    <>
      <TrendRankContainer type='networth' timeframe={ timeframe } />

      <ModuleWrapper title='Net Worth Change' anchor='networth_change' hint={ NETWORTH_CHANGE_HINT } expand={ isSingleMonth }>
        {
          isSingleMonth
            ? <NetworthChangeModuleContainer type='networth' timeframe={ timeframe } />
            : <NetworthMonthlyChangeModuleContainer type='networth' timeframe={ timeframe } />
        }
      </ModuleWrapper>

      {/*<TwoColumnRow left={ totalInflowsModule } right={ totalOutflowsModule } />*/}

      <PageFooterButton text='See Your Credit Profile' to='creditscore' />
    </>
  )

  const staticHeaderRef = useRef<HTMLDivElement>(null)
  const shouldShowStickyHeader = useShouldShowPageParamsStickyHeader(staticHeaderRef)

  const notifications = (
    <NotificationTrayWrapper
      renderLevel='page'
      placement='networth_general'
      isPositionRelative
    />
  )

  return (
    <InternalLayoutContainer
      sidebar={ <InternalSidebarContainer /> }
      notifications={ notifications }
      stickyHeader={ <PageParamsStickyHeader type='networth' /> }
      shouldShowStickyHeader={ shouldShowStickyHeader }
    >
      <Anchor placement='networth'>
        <Anchor placement='networth_general'>
          <DesktopInternalStickyHeader isShown={ shouldShowStickyHeader }>
            <PageParamsStickyHeader type='networth' />
          </DesktopInternalStickyHeader>
          <SingleColumnLayout
            header={ <PageParamsHeader type='networth' nodeRef={ staticHeaderRef } /> }
          >
            { pageBody }
          </SingleColumnLayout>
        </Anchor>
      </Anchor>
    </InternalLayoutContainer>
  )
}

export default NetworthPage
